import React, { FunctionComponent } from 'react';

const ForwardArrowIcon: FunctionComponent<React.PropsWithChildren<{ color: string }>> = ({
  color = 'black'
}) => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6 0.666626L5.06 1.60663L8.78 5.33329H0.666668V6.66663H8.78L5.06 10.3933L6 11.3333L11.3333 5.99996L6 0.666626Z"
      fill={color}
    />
  </svg>
);

export default ForwardArrowIcon;
